export default "__VITE_ASSET__yFSAU5hd__"